import { CADOperationTypeEnum } from "../enums";

export default function useCADAvailableOperations() {
    const availableOperationTypes: CADOperationTypeEnum[] = [CADOperationTypeEnum.EdgeProcessing, CADOperationTypeEnum.EdgeCutout, CADOperationTypeEnum.CornerCutout, CADOperationTypeEnum.InternalCutout, CADOperationTypeEnum.DrillHole];
    return availableOperationTypes;
}

